export default __webpack_public_path__ + "static/media/QuestGridLogo.a748c63d.png";